import { ArrowUpRight, Instagram, Mail, Phone } from "lucide-react";
import BrandMark from "@/components/BrandMark";
import Reveal from "@/components/Reveal";

const email = "van.akkeren.raeumungsservice@gmail.com";
const mailto = "mailto:van.akkeren.raeumungsservice@gmail.com?subject=Angebot%20anfragen%20%E2%80%93%20VanAkkeren%20R%C3%A4umungsservice";

export default function ContactSection({ standalone = false }) {
  return (
    <section className={`section contact-section ${standalone ? "contact-section-standalone" : ""}`} id="kontakt" data-testid="contact-section">
      <div className="container contact-grid">
        <Reveal className="contact-lead">
          <span className="eyebrow contact-eyebrow">Direkter Kontakt · 05 / 05</span>
          <h2 className="contact-title">Sie benötigen<br /><em>Unterstützung?</em></h2>
          <p>Schildern Sie uns kurz, was geräumt, transportiert oder umgezogen werden soll. Gerne erstellen wir Ihnen ein individuelles Angebot.</p>
          <a className="button button-dark" href={mailto} data-testid="contact-inquiry-button">Angebot anfragen <ArrowUpRight size={17} strokeWidth={1.8} /></a>
        </Reveal>
        <Reveal className="contact-panel" delay={120}>
          <div className="contact-panel-head"><span className="mono-label">VANAKKEREN / MÜLLHEIM</span><BrandMark testId="contact-brand-mark" compact /></div>
          <a className="contact-detail contact-phone" href="tel:+4915568199384" data-testid="contact-phone-link"><Phone size={20} /><span><small>Telefon</small>0155 68199384</span><ArrowUpRight size={17} /></a>
          <a className="contact-detail" href={mailto} data-testid="contact-email-link"><Mail size={20} /><span><small>E-Mail</small>{email}</span><ArrowUpRight size={17} /></a>
          <a className="contact-detail" href="https://www.instagram.com/van.akkeren.raeumungsservice/" target="_blank" rel="noreferrer" data-testid="contact-instagram-link"><Instagram size={20} /><span><small>Instagram</small>@van.akkeren.raeumungsservice</span><ArrowUpRight size={17} /></a>
          <p className="contact-panel-note">Eine kurze Nachricht genügt. Wir melden uns persönlich zurück.</p>
        </Reveal>
      </div>
    </section>
  );
}
